/**折上折,限时折扣,满减,满赠 */
export function discountHandle(_this, { discountlist, discount_rule }) {
  _this.fullDiscountEnter = -1
  /**折上折 */
  if (_this.discountrule && _this.discountrule.discountenable == 1) {
    discount_rule = _this.discountrule
    discountFunc()
  } else if (_this.fullDiscountRule && _this.fullDiscountRule.initdiscountenable == 1) {
    _this.fullDiscountRuleTitle =
      _this.fullDiscountRule.ruleObj && Object.keys(_this.fullDiscountRule.ruleObj).length > 1
        ? '限时折扣'
        : _this.fullDiscountRule.ruleObj[Object.keys(_this.fullDiscountRule.ruleObj)[0]].actlabel
    if (_this.fullDiscountRule.discountenable == 1) {
      Object.keys(_this.fullDiscountRule.ruleObj).forEach((key) => {
        let chooselen = _this.fullDiscountChooseNums[key]
        let rulelist = _this.fullDiscountRule.ruleObj[key].rulelist
        try {
          rulelist.forEach((item) => {
            if (chooselen >= parseFloat(item.num)) {
              discount_rule.discountlist = [
                ...(discount_rule.discountlist ? discount_rule.discountlist : {}),
                item
              ]
              throw new Error()
            }
          })
        } catch (e) {}
      })
      if (Object.keys(_this.fullDiscountRule.ruleObj).length > 1) {
        _this.fullDiscountEnter = 0
        if (_this.fullDiscountRule.fullDiscountmoney > 0) {
          _this.FlodMsg = '惊喜！已享受限时折扣'
        } else {
          _this.fullDiscountEnter = 1
          _this.FlodMsg = '惊喜！选购活动商品可享受更低折扣购买'
        }
      } else if (Object.keys(_this.fullDiscountRule.ruleObj).length == 1) {
        /**限时折扣 */
        discount_rule = {
          discountenable: _this.fullDiscountRule.discountenable,
          discountlist:
            _this.fullDiscountRule.ruleObj[Object.keys(_this.fullDiscountRule.ruleObj)[0]]
              .rulelist || []
        }
        discount_rule.discountlist.map((item) => {
          item.itemnum = item.num
        })
        _this.fullDiscountEnter = 0
        discountFunc()
      }
    }
    if (_this.fullDiscountRule.switch != 1) {
      _this.FlodMsg = ''
    }
  }
  function discountFunc(fn) {
    discountlist = discount_rule.discountlist
    if (parseInt(_this.goodsnum) == 0) {
      var discount = discountlist[0].discount
      discount = Math.round(discount * 100 * 100) / 100 /**处理精度 */
      var txt = discount % 10 == 0 ? discount / 10 : discount
      _this.FlodMsg = '惊喜！选购活动商品最高可享受' + txt + '折'
      if (_this.fullDiscountEnter == 0) _this.fullDiscountEnter = 1
      _this.currentdiscountdata = 1
    } else if (parseInt(_this.goodsnum) >= parseInt(discountlist[0].itemnum)) {
      let discount = discountlist[0].discount
      discount = Math.round(discount * 100 * 100) / 100 /**处理精度 */
      let txt = discount % 10 == 0 ? discount / 10 : discount
      if (_this.fullgiftrule.actstatus && parseInt(_this.fullgiftrule.actstatus) == 1) {
        _this.FlodMsg = ''
      } else {
        _this.FlodMsg = '惊喜！已选' + _this.goodsnum + '件享' + txt + '折'
      }
      if (_this.fullDiscountEnter == 0) _this.fullDiscountEnter = 1
      _this.currentdiscountdata = discount / 100
    } else if (parseInt(_this.goodsnum) < parseInt(discountlist[discountlist.length - 1].itemnum)) {
      let discount1 = discountlist[discountlist.length - 1].discount
      discount1 = Math.round(discount1 * 100 * 100) / 100 /**处理精度 */
      let txt = discount1 % 10 == 0 ? discount1 / 10 : discount1
      _this.FlodMsg =
        '惊喜！已选' +
        _this.goodsnum +
        '件，再加' +
        (parseInt(discountlist[discountlist.length - 1].itemnum) - _this.goodsnum) +
        '件即可享受' +
        txt +
        '折。'
      if (_this.fullDiscountEnter == 0) _this.fullDiscountEnter = 1
      _this.currentdiscountdata = 1
    } else {
      try {
        discountlist.forEach(function (item, index) {
          if (parseInt(_this.goodsnum) >= parseInt(item.itemnum)) {
            let discount1 = item.discount
            discount1 = Math.round(discount1 * 100 * 100) / 100 /**处理精度 */
            let discount2 = discountlist[index - 1].discount
            discount2 = Math.round(discount2 * 100 * 100) / 100 /**处理精度 */
            let txt = discount1 % 10 == 0 ? discount1 / 10 : discount1
            let txt1 = discount2 % 10 == 0 ? discount2 / 10 : discount2
            _this.FlodMsg =
              '惊喜！已选' +
              _this.goodsnum +
              '件享' +
              txt +
              '折，再加' +
              (parseInt(discountlist[index - 1].itemnum) - _this.goodsnum) +
              '件即可享受' +
              txt1 +
              '折。'
            if (_this.fullDiscountEnter == 0) _this.fullDiscountEnter = 1
            _this.currentdiscountdata = discount1 / 100
            throw new Error()
          }
        })
      } catch (e) {}
    }
  }
}

export function fullDiscountHandle(_this) {
  if (_this.fullDiscountRule && _this.fullDiscountRule.discountenable == 1) {
    _this.fullDiscountChooseNums = {}
    _this.list.forEach((item) => {
      if (
        item.isFullDiscount == 1 &&
        item.fullDiscountRuleId &&
        _this.fullDiscountRule.ruleObj &&
        Object.keys(_this.fullDiscountRule.ruleObj).length > 0
      ) {
        let ruleId = item.fullDiscountRuleId
        if (_this.fullDiscountChooseNums[ruleId]) {
          _this.fullDiscountChooseNums[ruleId] += parseInt(item.num)
        } else {
          _this.fullDiscountChooseNums[ruleId] = parseInt(item.num)
        }
      }
    })
    Object.keys(_this.fullDiscountRule.ruleObj).forEach((key) => {
      let chooselen = _this.fullDiscountChooseNums[key]
      let rulelist = _this.fullDiscountRule.ruleObj[key].rulelist
      try {
        rulelist.forEach((item) => {
          if (chooselen >= parseFloat(item.num)) {
            _this.fullDiscount[key] = item.discount
            throw new Error()
          }
        })
      } catch (e) {}
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/shopcart/js/addOrder.js